module.exports = __webpack_public_path__ + "img/card.46817128.png";